import { render, staticRenderFns } from "./AddSubscriptionDialog.vue?vue&type=template&id=a8a01e16&scoped=true"
import script from "./AddSubscriptionDialog.vue?vue&type=script&lang=js"
export * from "./AddSubscriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a01e16",
  null
  
)

export default component.exports